import React from 'react';

import { Row, Col } from 'components/bootstrap';
import { DocumentTitle, PageHeader } from 'components/common';

import DataLakeRetrievalsList from './DataLakeRetrievalsList';

import DataLakeJobs from '../components/DataLakeJobs';

const DataLakeRetrievalsPage = () => (
  <DocumentTitle title="Data Lake Retrievals">
    <PageHeader title="Data Lake Retrievals">
      <span>
        Retrieval Operatons from Data Lakes can be viewed on this page. This includes both Graylog&apos;s internal Data Lake, and External Data lakes such as Amazon Security Lake.
      </span>
    </PageHeader>
    <DataLakeJobs />
    <Row className="content">
      <Col md={12}>
        <DataLakeRetrievalsList />
      </Col>
    </Row>
  </DocumentTitle>
);

export default DataLakeRetrievalsPage;
